/**
 * Converts a string to lowercase and replaces empty spaces with dashes.
 * If the input is not a string, returns null.
 *
 * @param {string} inputString - The input string to be processed.
 * @returns {string|null} - The formatted string or null if the input is not a string.
 */
const formatDataTestId = inputString => {
  if (typeof inputString !== 'string') {
    return null;
  }
  return `-${inputString.trim().toLowerCase().replace(/\s+/g, '-')}`;
};

export default formatDataTestId;
